<template>
  <Wrapper
    id="section-active-frame"
    :position="sectionActive.position"
    v-show="!preview && renderTools && sectionActive.id"
    :class="{'top': !oversection || !isFirstIndex, 'bottom': oversection && isFirstIndex}"
    :isActiveCell="!!cellActive.id"
  >
  <!-- <pre>{{cellActive.id}}</pre>
  <pre>{{!!cellActive.id}}</pre> -->
  <!-- <pre>{{goTo('section')}}</pre> -->
  <!-- <pre>{{sectionActive}}</pre> -->
    <FloatframeActive class="text-center lbl-name" :lv="dt.lv" :class="{'disabled lbl-hover': !!cellActive.id}" v-if="!isGridOverlap" @click="!!cellActive.id && goTo('section')"> {{ $t('engine.floatframeTool.floatframeHover.section.lblSection', languageEngine) }} </FloatframeActive>
    <template>
      <SectionTool class="d-flex align-items-center section-tool" style="pointer-events: visible;" v-if="!cellActive.id && sectionActive.id != 'empty_section' && detectDevice == 'desktop'">
        <div class="d-flex justify-content-center align-items-center btn-tool-wrapper" 
          @click.stop.prevent="duplicateSection()"
          v-b-tooltip.hover
          :title="$t('engine.floatframeTool.floatframeActive.section.miniBtn.btnDuplicateSection', languageEngine)"
          v-if="!isSectionPage"
        >
          <i class="icon-fa mt-1 far fa-clone"></i>
        </div>
        <div class="justify-content-center align-items-center btn-tool-wrapper d-flex" 
          v-b-tooltip.hover 
          :title="$t('engine.floatframeTool.floatframeActive.section.miniBtn.btnUpSection', languageEngine)"
          :class="{'disabled': !isShowUp}"
          :style="`pointer-events: ${!isShowUp ? 'none' : 'all'}`"
          @click.stop.prevent="moveSectionUp()"
        >
          <i class="icon-fa mt-1 far fa-arrow-up"></i>
        </div>
        <div class="justify-content-center align-items-center btn-tool-wrapper"
          v-b-tooltip.hover
          :title="$t('engine.floatframeTool.floatframeActive.section.miniBtn.btnDownSection', languageEngine)"
          :class="{'disabled': !isShowDown}"
          :style="`pointer-events: ${!isShowDown ? 'none' : 'all'}`"
          @click.stop.prevent="moveSectionDown()"
        >
          <i class="icon-fa mt-1 far fa-arrow-down"></i>
        </div>
        <div class="d-flex justify-content-center align-items-center btn-tool-wrapper" 
          v-b-tooltip.hover 
          :title="$t('engine.floatframeTool.floatframeActive.section.miniBtn.btnRemoveSection', languageEngine)"
          v-if="!isSectionPage"
          @click.stop.prevent="removeSection()"
        >
          <i class=" icon-fa mt-1 far fa-trash-alt"></i>
        </div>
      </SectionTool>
      <AddSection
        class="add-section top"
        style="pointer-events: none;"
        v-if="!cellActive.id && sectionActive.id != 'empty_section' && detectDevice == 'desktop' && !isExamplePage"
      >
        <div class="center-hv w-100 d-flex justify-content-center">
          <div class="d-flex justify-content-center icon-section-wrapper" style="pointer-events: auto;">
            <div class="icon-hover-label btn-hover" @click.stop.prevent="addSection('up')">
              <span class="text-white icon-wrapper">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icon-label">
                  {{ $t('engine.floatframeTool.floatframeActive.section.btnAddSection', languageEngine) }}
              </span>
            </div>
          </div>
        </div>  
      </AddSection>
      <AddSection
        v-if="!isSectionPage && !cellActive.id && sectionActive.id != 'empty_section' && detectDevice == 'desktop'"
        class="add-section bottom"
        style="pointer-events: none;"
      >
        <div class="center-hv w-100 d-flex justify-content-center">
          <div class="d-flex justify-content-center icon-section-wrapper" style="pointer-events: auto;">
            <div class="icon-hover-label btn-hover" @click.stop.prevent="addSection('down')">
              <span class="text-white icon-wrapper">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icon-label">
                  {{ $t('engine.floatframeTool.floatframeActive.section.btnAddSection', languageEngine) }}
              </span>
            </div>
          </div>
        </div>
      </AddSection>
    </template>
  </Wrapper>
</template>
<script>
import {
  SectionTool,
  AddSection,
  FloatframeActive,
  Wrapper,
} from "@components/tool/FloatFrameActive.styled.js";
import { mapGetters } from "vuex";
import { SECTION_TYPE_NONE_SETTING } from "@model/components/componentMeta.model";

export default {
  components: {
    SectionTool,
    AddSection,
    FloatframeActive,
    Wrapper,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
    }
  },
  computed: {
    ...mapGetters({
      detectDevice: "detectDevice",
      scrollPosition: "scrollPosition",
      components: "designIframe/metadata/components",
      CONTENT_CONTAINER: "designIframe/metadata/CONTENT_CONTAINER",
      preview: "designIframe/preview",
      sectionActive: "designIframe/frame/sectionActive",
      renderTools: "designIframe/frame/renderTools",
      cellActive: "designIframe/frame/cellActive",
      gridActive: "designIframe/frame/gridActive",
      isExamplePage: "designIframe/page/isExamplePage",
      siteComponents: "designIframe/metadata/siteComponents",
      sitePageID: "designIframe/metadata/sitePageID",
      languageEngine: "designIframe/userPreference/languageEngine",
      limit: "designIframe/page/limit",
    }),
    dt() {
      return {
        name: "",
        id: undefined,
        lv: 0,
        ...this.sectionHover,
      };
    },
    sections() {
      return this.CONTENT_CONTAINER.componentsID;
    },
    indexSection() {
      return this.CONTENT_CONTAINER.componentsID.indexOf(this.sectionActive.id);
    },
    isSectionPage() {
      return this.sectionActive.id === "SECTION_PAGE";
    },
    isPageSystem() {
      const index = this.CONTENT_CONTAINER.componentsID.indexOf("SECTION_PAGE");
      return index >= 0;
    },
    isBeforeLastIndex() {
      const index = this.CONTENT_CONTAINER.componentsID.indexOf(this.sectionActive.id);
      return this.CONTENT_CONTAINER.componentsID.length - 2 == index;
    },
    isFirstIndex() {
      return this.indexSection == 0;
    },
    isLastIndex() {
      return (
        this.CONTENT_CONTAINER.componentsID.length - 1 == this.indexSection
      );
    },
    isShowUp() {
      let show = true;
      if (this.isSectionPage) {
        show = false;
      } else {
        if (this.isFirstIndex) {
          show = false;
        } else {
          show = true;
        }
      }
      return show;
    },
    isShowDown() {
      let show = true;
      if (this.isSectionPage) {
        show = false;
      } else {
        if (this.isBeforeLastIndex && this.isPageSystem) {
          show = false;
        } else {
          show = true;
          if (this.isLastIndex) {
            show = false;
          }
        }
      }
      return show;
    },
    isOverScroll() {
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    sectionComponent() {
      return this.sectionActive && this.components[this.sectionActive.id]
    },
    gridMarginTop() {
      return (
        this.components[this.gridActive.id] &&
        this.components[this.gridActive.id].style.marginTop
      );
    },
    indexGrid() {
      return this.gridActive.id && this.sectionComponent.componentsID.indexOf(this.gridActive.id);
    },
    isGridFirstIndex() {
      return this.indexGrid == 0;
    },
    isGridOverlap() {
      return this.sectionComponent && this.sectionComponent.style.width == 'container-fluid' && this.isGridFirstIndex && this.gridMarginTop == 0
    },
    getMainPage() {
      const mainPageID =
        this.siteComponents &&
        this.siteComponents.MAIN_PAGE &&
        this.siteComponents.MAIN_PAGE.properties &&
        this.siteComponents.MAIN_PAGE.properties.pageID;
      return mainPageID;
    },
    oversection() {
      return (
        this.sitePageID == this.getMainPage && this.HEADER.style.isEnableOverSection
      );
    },
    HEADER() {
      return this.siteComponents.HEADER;
    },
  },
  methods: {
    addSection(direction) {
      const sectionCountInPage = this.sections.length;
      if(!this.limit.section || sectionCountInPage < this.limit.section) {
        this.$store.commit("designIframe/setStatePath", {
          value: {
            sectionID: this.sectionActive.id,
            direction,
          },
          path: "/component/addComponent/section",
        });
        this.$store.dispatch("design/setMode", {
          mode: "add_section",
        });
      }
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-section",
          payload: {},
        });
      }
    },
    classPositionTool() {
      const element = document.getElementById("section-active-frame");
      if(element) {
        const rect = element.getBoundingClientRect();
        const topSpace = rect.top;
        const leftSpace = rect.left;
        const rightSpace =
          document.documentElement.clientWidth - (leftSpace + rect.width);
        const bottom =
          document.documentElement.clientHeight - (topSpace + rect.height);
        const toolHeight = -40;
         if (topSpace <= 0 && leftSpace <= 0 && rightSpace <= 0 && bottom <= 0) {
          this.positionTool = "overscreen";
        } else {
          this.positionTool = [
            {
              value: topSpace + toolHeight,
              class: "top"
            },
            {
              value: bottom + toolHeight,
              class: "bottom"
            },
          ].sort((a, b) => b.value - a.value)[0].class;
        }
      }
    },
    duplicateSection() {
      const sectionCountInPage = this.sections.length;
      if(!this.limit.section || sectionCountInPage < this.limit.section) {
        this.$store.commit("designIframe/setStatePath", {
          value: {
            sectionID: this.sectionActive.id,
          },
          path: "/component/addComponent/section",
        });
        this.$store.dispatch("designIframe/component/duplicateSection", {
          component_id: this.sectionActive.id,
        });

        this.$store.dispatch("designIframe/snapshot/genSnapshot");
      }
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-section",
          payload: {},
        });
      }
    },
    moveSectionUp() {
      if (!this.isShowUp) return
      this.$store.dispatch("designIframe/component/moveSectionUp", {
        id: this.sectionActive.id,
      });
    },
    moveSectionDown() {
      if (!this.isShowDown) return
      this.$store.dispatch("designIframe/component/moveSectionDown", {
        id: this.sectionActive.id,
      });
    },
    removeSection() {
      this.$store.dispatch("designIframe/component/removeSection", {
        id: this.sectionActive.id,
      });
      this.$store.dispatch("designIframe/frame/setSectionHover", {});
      this.$store.dispatch("designIframe/frame/setSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
    },
    goTo(type) {
      switch (type) {
        case "section": {
          var compID = this.sectionActive.id;
          this.$store.dispatch("designIframe/frame/setSectionActive", {
            component_id: compID,
            name: compID,
          });
          this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
          this.$store.dispatch("designIframe/frame/setCellActive", {});
          this.$store.dispatch("designIframe/frame/setCellHover", {});
          this.$store.dispatch("designIframe/frame/setWidgetActive", {});
          this.$store.dispatch("designIframe/frame/setWidgetHover", {});
          // this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
          this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});

          let noneSetting = false;
          SECTION_TYPE_NONE_SETTING.find((type) => {
            Object.entries(this.components).forEach((item) => {
              if (type === item[1].type && item[1].id === this.sectionActive.id) {
                noneSetting = true;
              }
            })
          });
          if (noneSetting) {
            this.$store.dispatch("design/component/elActive", {});
          } else {
            this.$store.dispatch("design/component/elActive", {
              elementID: ["component", compID],
            });
          }
          break;
        }
        default:
          break;
      }
    },
  },
  watch: {
    sectionActive: {
      deep: true,
      handler() {
        const element = document.getElementById("section-active-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  }
};
</script>

<style lang="scss">
  .icon-section-wrapper {
    position: relative;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    .icon-hover-label {
      position: relative;
      display: inline-block;
      white-space: nowrap;
      outline: none;
      transition: ease-out 0.3s;
      height: 30px;
      background: #12A9FF;
      border-radius: 20px;
      width: 100% !important;
      padding: 3px 10px;
      .icon-label {
        white-space: nowrap;
        pointer-events: none;
        color: #ffffff;
        opacity: 1;
        position: static;
        transition: ease-out 0.3s;
      }
      .icon-wrapper {
        left: 20%;
      }
    }
  }
  .btn-tool-wrapper {
    &:hover {
      .icon-fa {
        color: #24BEE2;

      }
    }
    &.disabled {
      .icon-fa {
        color: #AEB5BD
      }
    }
  }
</style>